
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import colors from '../../styles/colors';

const AlertDialog = (props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      PaperProps={{
        sx: {
          minWidth: '300px',
          margin: 'auto',
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <span style={{ color: colors.primary }}>{props.title}</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ minWidth: '300px' }} id="alert-dialog-description">
          {props.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          style={{ backgroundColor: colors.primary, color: "white" }}
          onClick={props.onClose}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AlertDialog;



// WEBPACK FOOTER //
// ./src/components/common/AlertDialog.js